export const AppHeader = () => import('../../../../components/AppHeader.vue' /* webpackChunkName: "components/app-header" */).then(c => wrapFunctional(c.default || c))
export const AppImg = () => import('../../../../components/AppImg.vue' /* webpackChunkName: "components/app-img" */).then(c => wrapFunctional(c.default || c))
export const AppLink = () => import('../../../../components/AppLink.vue' /* webpackChunkName: "components/app-link" */).then(c => wrapFunctional(c.default || c))
export const AppLoader = () => import('../../../../components/AppLoader.vue' /* webpackChunkName: "components/app-loader" */).then(c => wrapFunctional(c.default || c))
export const ArtworkAsset = () => import('../../../../components/ArtworkAsset.vue' /* webpackChunkName: "components/artwork-asset" */).then(c => wrapFunctional(c.default || c))
export const CardArtwork = () => import('../../../../components/CardArtwork.vue' /* webpackChunkName: "components/card-artwork" */).then(c => wrapFunctional(c.default || c))
export const FormSubscribe = () => import('../../../../components/FormSubscribe.vue' /* webpackChunkName: "components/form-subscribe" */).then(c => wrapFunctional(c.default || c))
export const GLView = () => import('../../../../components/GLView.vue' /* webpackChunkName: "components/g-l-view" */).then(c => wrapFunctional(c.default || c))
export const RelatedArtists = () => import('../../../../components/RelatedArtists.vue' /* webpackChunkName: "components/related-artists" */).then(c => wrapFunctional(c.default || c))
export const SmoothWrapper = () => import('../../../../components/SmoothWrapper.vue' /* webpackChunkName: "components/smooth-wrapper" */).then(c => wrapFunctional(c.default || c))
export const UIBtn = () => import('../../../../components/UIBtn.vue' /* webpackChunkName: "components/u-i-btn" */).then(c => wrapFunctional(c.default || c))
export const UIToggle = () => import('../../../../components/UIToggle.vue' /* webpackChunkName: "components/u-i-toggle" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
